"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _JobScheduleSlotsSchedule2 = _interopRequireDefault(require("./__generated__/JobScheduleSlotsSchedule.graphql"));
var React = _interopRequireWildcard(require("react"));
var _reactRelay = require("react-relay");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DataTable = _interopRequireDefault(require("web/shared/components/DataTable"));
var _JobSchedule = require("web/shared/jobs/JobSchedule.columns");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What this product is declared to run, grouped by the time of day it fires.
*
* The suspending half of the schedule page: it reads on render, so the loading
* and failure lines belong to the frame above.
*/
const DOCUMENT = _JobScheduleSlotsSchedule2.default; // One time-of-day and every job declared to run at it.
// One job as the schedule view names it, which is what its columns render.
function JobScheduleSlots(props) {
  const data = (0, _reactRelay.useLazyLoadQuery)(DOCUMENT, {}, {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  });
  const slots = data.internalJobSchedule;
  if (slots.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
      children: "This product declares no scheduled jobs."
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: slots.map(slot => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.subHeading)), {}, {
        children: slot.at
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DataTable.default, {
        columns: _JobSchedule.SCHEDULE_COLUMNS,
        rows: slot.jobs,
        rowKey: job => job.jobKey,
        emptyMessage: "No jobs at this time."
      })]
    }, slot.at))
  });
}
var _default = exports.default = JobScheduleSlots;